import React from "react";
import { Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'

const BusinessAreas = () => {
  const tags = [
    {
      text: 'Отделы продаж',
      color: 'rgba(239, 165, 223, 0.2)'
    },
    {
      text: 'Call-центры',
      color: 'rgba(255, 143, 12, 0.2)'
    },
    {
      text: 'Маркетинговые агентства',
      color: 'rgba(251, 106, 110, 0.2)'
    },
    {
      text: 'Онлайн-школы',
      color: 'rgba(0, 198, 158, 0.2)'
    },
    {
      text: 'Строительные компании',
      color: 'rgba(95, 200, 231, 0.2)'
    },
    {
      text: 'Фитнес-центры',
      color: 'rgba(241, 141, 100, 0.2)'
    },
    {
      text: 'Автосалоны',
      color: 'rgba(111, 108, 255, 0.2)'
    },
    {
      text: 'Агентства недвижимости',
      color: 'rgba(95, 200, 231, 0.2)'
    },
    {
      text: 'Интернет-магазины',
      color: 'rgba(111, 108, 255, 0.2)'
    },
    {
      text: 'Салоны красоты',
      color: 'rgba(139, 109, 187, 0.2)'
    }
  ]

  return (
    <Screen
      title={<span><StyledScreen.GreenText>Сферы</StyledScreen.GreenText> бизнеса наших клиентов</span>}
    >
      <Styled.TagsContainer>
        <Styled.TagsRow>
          {
            tags.map(tag => (
              <Styled.TagWrapp>
                <Styled.Tag color={tag.color}>{tag.text}</Styled.Tag>
              </Styled.TagWrapp>
            ))
          }
        </Styled.TagsRow>
      </Styled.TagsContainer>
    </Screen>
  )
}

export { BusinessAreas }